
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class TableIcon extends Vue {
    @Prop(String) readonly text!: string;
    @Prop({type: String, default: undefined}) readonly icon?: string;
    @Prop(Boolean) readonly disabled!: boolean;
    @Prop({ required: false, type: Boolean }) customIconStyle!: boolean;


    get customStyleButton() {
      return {
        'myCustomStyle rounded-md border-1 border-pink-500': this.customIconStyle
      };
    }
  }
